import React from "react";
import { useSelector } from "react-redux";

import { IgLink, IgTextField, IgTypography } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";
import { selectedCurrentCustomEvent } from "@src/store/slices/customEvents";

export const JsImportedEvent = () => {
  const currentEvent = useSelector(selectedCurrentCustomEvent);

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-start"}
      wrap={"nowrap"}
    >
      <Grid container marginTop={"30px"} width={"100%"} direction={"column"}>
        <IgTypography fontWeight={600}>
          Event Identifier (in theme code)
        </IgTypography>
        <IgTextField
          disabled={true}
          value={currentEvent?.identifier}
          sx={{ marginTop: "15px" }}
        ></IgTextField>
      </Grid>
      <Grid marginTop={"30px"} width={"100%"}>
        <IgTypography fontWeight={600}>Event Code</IgTypography>
      </Grid>
      <Grid marginTop={"10px"}>
        <IgTypography>
          This event is triggered by custom code in your shop's theme files.
          <br />
          Open the{" "}
          <IgLink onClick={() => window.open(`https://admin.shopify.com/`)}>
            Shopify Theme Editor
          </IgLink>{" "}
          to view and modify the event definition.
        </IgTypography>{" "}
      </Grid>
    </Grid>
  );
};
